import React, { Component } from 'react';
import NoteTagList from '../../theme/buttons/NoteTag';
import { connect } from 'react-redux';
import { setSessionVar } from '../../../store/actions';

class DistrictTurfListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false,
    };
  }

  onMouseEnter = () => {
    this.setState({ hovered: true });
    this.props.onMouseEnter && this.props.onMouseEnter();
  };

  onMouseLeave = () => {
    this.setState({ hovered: false });
    this.props.onMouseLeave && this.props.onMouseLeave();
  };

  renderDistictAggs = () => {
    let { data } = this.props;
    let cut_ratio = ((data.walkable_cut || 0) + (data.unwalkable_cut || 0)) / data.household_count;
    let attempt_ratio = (data.attempted || 0) / data.household_count;

    return (
      <>
        <div className="obj-data">
          <span>
            <b>{data.household_count}</b> Doors, <b>{data.turf_count || 0}</b> Turfs
          </span>
        </div>
        <div className="obj-data">
          <span>
            <b className={cut_ratio > 0.98 ? 'success-text' : 'danger-text'}>
              {Math.round(cut_ratio * 100)}% cut
            </b>{' '}
            -- {data.walkable_cut || 0} walkable,{' '}
            <span className={data.unwalkable_cut > 0 ? 'danger-text' : ''}>
              {data.unwalkable_cut || 0} not
            </span>
          </span>
        </div>
        {!!data.attempted && (
          <div className="obj-data">
            <span>
              <b className={'success-text'}>{data.attempted} attempted</b> (
              {Math.round(attempt_ratio * 100)}%)
            </span>
          </div>
        )}
        <div
          className={'clickable-children'}
          onClick={(e) => {
            e.stopPropagation();
            this.props.setDistrictModalDistricts([data]);
          }}
          style={{ marginTop: '.5em' }}
        >
          <NoteTagList notes={data.notes} addButton />
        </div>
      </>
    );
  };

  renderTurfAggs = () => {
    let { data } = this.props;

    return (
      <>
        {!!data.household_count && (
          <>
            <div className="obj-data">
              <span>
                <b>{data.household_count}</b> Doors
              </span>{' '}
              {!!data.target_count && (
                <span>
                  / <b>{data.target_count}</b> Targets
                </span>
              )}
            </div>
            {data.household_count_before_suppression &&
              data.household_count_before_suppression > data.household_count && (
                <div className="obj-data danger-text">
                  <span>
                    <i className="fas fa-exclamation-triangle" style={{ paddingRight: '.5em' }} />
                    <b>{data.household_count_before_suppression - data.household_count}</b> Doors
                    Suppressed
                  </span>
                </div>
              )}
          </>
        )}
        {!!data.agg_data && (
          <div className="obj-data primary-text">
            {data.agg_data.households_attempted} doors / {data.agg_data.targets_attempted} targets
            attempted.
          </div>
        )}
        {!!data.code_name && <div className="obj-data">{data.code_name}</div>}
        {/* data.notes has been deprecated, to remove in a future release. We now use notes below.*/}
        <div
          className={'clickable-children'}
          onClick={(e) => {
            // e.stopPropagation();
            this.props.setTurfModalTurfs([data]);
          }}
          style={{ marginTop: '.5em' }}
        >
          <NoteTagList notes={data.turfnotes} addButton />
        </div>
      </>
    );
  };

  render() {
    let { data, focused } = this.props;

    return (
      <div
        className={`side-menu-list-obj district ${focused && 'focused'}`}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        id={data.id}
        onClick={this.props.onClick}
        onDoubleClick={this.props.onDoubleClick}
      >
        {this.props.onRemove && (
          <i
            className="remove-seat-icon far fa-times-circle fa-pull-right"
            onClick={this.props.onRemove}
          />
        )}
        {/*inner wrapper to generate side color border*/}
        <div
          className="list-obj-inner-wrapper"
          style={{
            borderLeftColor: this.props.color,
            borderLeftWidth: this.state.hovered ? '6px' : null,
          }}
        >
          <div className="obj-title" onClick={this.props.onClick}>
            {data.name}
          </div>

          {/*THIS IS DISTRICT SPECIFIC*/}
          {!!this.props.isDistrict && this.renderDistictAggs()}

          {/*THIS IS TURF SPECIFIC*/}
          {!this.props.isDistrict && this.renderTurfAggs()}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  setDistrictModalDistricts: (district) =>
    dispatch(setSessionVar('districtNoteModalDistricts', district)),
  setTurfModalTurf: (turf) => dispatch(setSessionVar('turfNoteModalTurf', turf)),
});

export default connect(null, mapDispatchToProps)(DistrictTurfListItem);
